/* =========================================================
   Nahr Al Asal — theme.js (vanilla, no dependencies)
   ========================================================= */
(function () {
  'use strict';
  var T = window.Theme || {};
  var R = T.routes || {};
  var S = T.strings || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var on = function (el, ev, fn, opt) { if (el) el.addEventListener(ev, fn, opt); };
  var root = (R.root || '/').replace(/\/?$/, '/');
  var store = {
    get: function (k, d) { try { var v = localStorage.getItem('nahr:' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } },
    set: function (k, v) { try { localStorage.setItem('nahr:' + k, JSON.stringify(v)); } catch (e) {} }
  };
  var pad = function (n) { return String(n).padStart(2, '0'); };
  var esc = function (s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };

  /* ---------- money ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Math.round(Number(cents) || 0);
    format = format || T.moneyFormat || '{{amount}}';
    var rx = /\{\{\s*(\w+)\s*\}\}/;
    function delim(n, prec, th, dec) {
      th = th == null ? ',' : th; dec = dec == null ? '.' : dec;
      var fixed = (n / 100).toFixed(prec);
      var parts = fixed.split('.');
      var d = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + th);
      return d + (parts[1] ? dec + parts[1] : '');
    }
    var m = format.match(rx); var key = m ? m[1] : 'amount'; var val;
    switch (key) {
      case 'amount': val = delim(cents, 2); break;
      case 'amount_no_decimals': val = delim(cents, 0); break;
      case 'amount_with_comma_separator': val = delim(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': val = delim(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': val = delim(cents, 2, "'", '.'); break;
      case 'amount_no_decimals_with_space_separator': val = delim(cents, 0, ' ', ''); break;
      default: val = delim(cents, 2);
    }
    if (T.hideDecimals || key === 'amount') val = val.replace(/[.,]00$/, '');
    return format.replace(rx, val).replace(/<[^>]*>/g, '');
  }
  T.formatMoney = formatMoney;

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg) {
    var el = $('#Toast'); if (!el || !msg) return;
    el.textContent = msg; el.classList.add('is-on');
    clearTimeout(toastT); toastT = setTimeout(function () { el.classList.remove('is-on'); }, 2400);
  }
  T.toast = toast;

  /* ---------- panels (drawer / search / menu) ---------- */
  function openPanel(name) {
    var p = $('[data-panel="' + name + '"]'); if (!p) return false;
    $$('[data-panel].is-open').forEach(function (x) { if (x !== p) x.classList.remove('is-open'); });
    p.classList.add('is-open'); document.body.classList.add('lock');
    var inp = $('input[type=search]', p); if (inp) setTimeout(function () { inp.focus(); }, 80);
    return true;
  }
  function closePanels() {
    $$('[data-panel].is-open, .modal.is-open').forEach(function (x) { x.classList.remove('is-open'); });
    document.body.classList.remove('lock');
  }
  T.openPanel = openPanel; T.closePanels = closePanels;
  on(document, 'click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var name = o.getAttribute('data-open');
      if (name === 'cart' && T.cartType === 'page') return;
      if (openPanel(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]')) { e.preventDefault(); closePanels(); }
  });
  on(document, 'keydown', function (e) { if (e.key === 'Escape') closePanels(); });

  /* ---------- header scroll ---------- */
  var hdr = $('[data-header]');
  if (hdr) on(window, 'scroll', function () { hdr.classList.toggle('is-scrolled', window.scrollY > 10); }, { passive: true });

  /* ---------- reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- announcement slider ---------- */
  $$('.announce--slider[data-announce]').forEach(function (a) {
    var items = $$('.announce__item', a); if (items.length < 2) return;
    var i = 0, iv = (+a.getAttribute('data-interval') || 4) * 1000;
    setInterval(function () { items[i].classList.remove('is-active'); i = (i + 1) % items.length; items[i].classList.add('is-active'); }, iv);
  });

  /* ---------- countdowns ---------- */
  function parseDate(s) {
    if (!s) return null;
    var m = String(s).trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?/);
    if (!m) return null;
    return new Date(+m[1], +m[2] - 1, +m[3], +(m[4] || 23), +(m[5] || 59), 59).getTime();
  }
  function globalEnd() {
    var c = T.countdown || {}; var now = Date.now();
    if (c.mode === 'date') { var d = parseDate(c.date); if (d && d > now) return d; }
    if (c.mode === 'evergreen') {
      var k = store.get('cd-end', 0);
      if (!k || k < now) { k = now + (c.hours || 6) * 3600000; store.set('cd-end', k); }
      return k;
    }
    var e = new Date(); e.setHours(24, 0, 0, 0); return e.getTime();
  }
  function cutoffEnd() {
    var h = +T.shipCutoff; if (!(h >= 0 && h < 24)) h = 24;
    var e = new Date(); e.setHours(h, 0, 0, 0);
    if (e.getTime() <= Date.now()) e.setDate(e.getDate() + 1);
    return e.getTime();
  }
  function tickCountdowns() {
    var now = Date.now(), gEnd = globalEnd();
    $$('[data-countdown]').forEach(function (el) {
      var end = parseDate(el.getAttribute('data-end')) || gEnd;
      var r = Math.max(0, Math.floor((end - now) / 1000));
      var hasD = !!$('[data-cd="d"]', el);
      var d = Math.floor(r / 86400), h = Math.floor(r / 3600), m = Math.floor(r % 3600 / 60), s = r % 60;
      if (hasD) h = h % 24;
      var set = function (k, v) { var x = $('[data-cd="' + k + '"]', el); if (x) x.textContent = pad(v); };
      set('d', d); set('h', h); set('m', m); set('s', s);
    });
    var ce = cutoffEnd(), cr = Math.max(0, Math.floor((ce - now) / 1000));
    var ct = pad(Math.floor(cr / 3600)) + ':' + pad(Math.floor(cr % 3600 / 60)) + ':' + pad(cr % 60);
    $$('[data-cutoff-time]').forEach(function (el) { el.textContent = ct; });
  }
  tickCountdowns(); setInterval(tickCountdowns, 1000);

  /* ---------- date helpers (ETA / timeline) ---------- */
  var lang = document.documentElement.lang || 'ar';
  var loc = /^ar/.test(lang) ? 'ar-EG' : lang;
  function dayStr(n, opt) { var x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString(loc, opt || { weekday: 'short', day: 'numeric', month: 'short' }); }
  $$('[data-tl-date]').forEach(function (el) {
    var v = el.getAttribute('data-tl-date').split('-');
    el.textContent = v.length > 1 ? dayStr(+v[0]) + ' – ' + dayStr(+v[1]) : dayStr(+v[0]);
  });
  $$('[data-eta]').forEach(function (box) {
    var sel = $('[data-eta-select]', box), out = $('[data-eta-out]', box); if (!sel) return;
    var upd = function () { var v = sel.value.split('-'); out.textContent = 'من ' + dayStr(+v[0], { weekday: 'long', day: 'numeric', month: 'short' }) + ' لـ ' + dayStr(+v[1], { weekday: 'long', day: 'numeric', month: 'short' }); };
    on(sel, 'change', upd); upd();
  });

  /* ---------- carousels ---------- */
  $$('[data-carousel]').forEach(function (c) {
    var sec = c.closest('.sec') || c.parentNode;
    var step = function (dir) {
      var item = c.firstElementChild; var w = item ? item.getBoundingClientRect().width + 14 : 300;
      var rtl = getComputedStyle(c).direction === 'rtl';
      c.scrollBy({ left: (rtl ? -1 : 1) * dir * w, behavior: 'smooth' });
    };
    on($('[data-car-next]', sec), 'click', function () { step(1); });
    on($('[data-car-prev]', sec), 'click', function () { step(-1); });
    var ap = +c.getAttribute('data-autoplay');
    if (ap) {
      var paused = false; on(c, 'pointerenter', function () { paused = true; }); on(c, 'pointerleave', function () { paused = false; });
      setInterval(function () {
        if (paused) return;
        var max = c.scrollWidth - c.clientWidth;
        if (Math.abs(c.scrollLeft) >= max - 4) c.scrollTo({ left: 0, behavior: 'smooth' }); else step(1);
      }, ap * 1000);
    }
  });

  /* ---------- accordion ---------- */
  $$('[data-accordion]').forEach(function (acc) {
    $$('details', acc).forEach(function (d) {
      on(d, 'toggle', function () { if (d.open) $$('details', acc).forEach(function (o) { if (o !== d) o.open = false; }); });
    });
  });

  /* ---------- copy ---------- */
  on(document, 'click', function (e) {
    var c = e.target.closest('[data-copy]'); if (!c) return;
    var txt = c.getAttribute('data-copy');
    if (navigator.clipboard) navigator.clipboard.writeText(txt).then(function () { toast('✓ اتنسخ: ' + txt); });
  });

  /* =========================================================
     CART
     ========================================================= */
  var cartState = null;
  function fetchJSON(url, opts) {
    return fetch(url, opts).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function postJSON(url, body) {
    return fetchJSON(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
  }
  function getCart() { return fetchJSON(root + 'cart.js').then(function (c) { cartState = c; return c; }); }
  T.getCart = getCart;

  function sectionIds() {
    var ids = [];
    $$('[data-cart-drawer][data-section-id], [data-main-cart][data-section-id]').forEach(function (el) { ids.push(el.getAttribute('data-section-id')); });
    return ids;
  }
  function renderCartSections() {
    var ids = sectionIds();
    var p = ids.length ? fetchJSON(root + '?sections=' + ids.join(',')).then(function (res) {
      ids.forEach(function (id) {
        var html = res[id]; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var cur = $('[data-section-id="' + id + '"]');
        if (!cur) return;
        if (cur.hasAttribute('data-cart-drawer')) {
          var nd = $('.drawer', doc), od = $('.drawer', cur);
          if (nd && od) od.innerHTML = nd.innerHTML;
        } else {
          var nn = $('[data-section-id="' + id + '"]', doc);
          if (nn) cur.innerHTML = nn.innerHTML;
        }
      });
    }).catch(function () {}) : Promise.resolve();
    return p.then(getCart).then(function (c) { updateCounts(c); bindCartUI(); document.dispatchEvent(new CustomEvent('cart:updated', { detail: c })); return c; });
  }
  function updateCounts(c) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; el.setAttribute('data-count', c.item_count); });
  }

  var giftBusy = false;
  function syncGift(c) {
    var g = T.gift || {};
    if (!g.on || !g.auto || !g.variant || !g.at || giftBusy) return Promise.resolve(c);
    var giftLine = null, total = 0;
    c.items.forEach(function (it) { if (it.variant_id === g.variant && it.properties && it.properties._gift) giftLine = it; else total += it.final_line_price; });
    var at = g.at * (T.currencyRate || 1);
    if (total >= at && !giftLine) {
      giftBusy = true;
      return postJSON(root + 'cart/add.js', { items: [{ id: g.variant, quantity: 1, properties: { _gift: '1' } }] }).catch(function () {}).then(function () { giftBusy = false; return true; });
    }
    if (total < at && giftLine) {
      giftBusy = true;
      return postJSON(root + 'cart/change.js', { id: giftLine.key, quantity: 0 }).catch(function () {}).then(function () { giftBusy = false; return true; });
    }
    return Promise.resolve(false);
  }

  function afterCartChange(openDrawer) {
    return getCart().then(syncGift).then(renderCartSections).then(function (c) {
      if (openDrawer) {
        if (T.cartType === 'page') { window.location.href = R.cart; return c; }
        if (T.cartType === 'toast' || !$('[data-panel="cart"]')) { toast(S.added); return c; }
        openPanel('cart');
      }
      return c;
    });
  }

  function addItems(items, opts) {
    opts = opts || {};
    return postJSON(root + 'cart/add.js', { items: items }).then(function () {
      return afterCartChange(opts.open !== false);
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || S.error);
      throw err;
    });
  }
  T.addItems = addItems;

  function changeLine(key, qty) {
    var line = $$('[data-line-key="' + key + '"]'); line.forEach(function (l) { l.classList.add('is-busy'); });
    return postJSON(root + 'cart/change.js', { id: key, quantity: qty }).then(function () { return afterCartChange(false); })
      .catch(function (err) { toast((err && err.description) || S.error); line.forEach(function (l) { l.classList.remove('is-busy'); }); });
  }

  function applyCode(code, msgEl) {
    code = (code || '').trim(); if (!code) return Promise.resolve();
    return getCart().then(function (c) {
      var existing = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return x.toUpperCase() !== code.toUpperCase(); });
      existing.push(code);
      return postJSON(root + 'cart/update.js', { discount: existing.join(',') });
    }).then(function (c) {
      var hit = (c.discount_codes || []).filter(function (d) { return d.code.toUpperCase() === code.toUpperCase(); })[0];
      var ok = hit && hit.applicable;
      if (msgEl) { msgEl.hidden = false; msgEl.className = 'form-msg ' + (ok ? 'form-msg--ok' : 'form-msg--err'); msgEl.textContent = ok ? S.couponOk : S.couponBad; }
      if (!ok && hit) {
        var keep = (c.discount_codes || []).filter(function (d) { return d.applicable; }).map(function (d) { return d.code; });
        return postJSON(root + 'cart/update.js', { discount: keep.join(',') }).then(function () { return afterCartChange(false); });
      }
      if (ok) toast(S.couponOk);
      return afterCartChange(false);
    }).catch(function () {
      return fetch(root + 'discount/' + encodeURIComponent(code)).then(function () { toast(S.couponOk); return afterCartChange(false); });
    });
  }
  T.applyCode = applyCode;

  var noteT;
  function bindCartUI() {
    $$('[data-coupon-form]').forEach(function (f) {
      if (f._b) return; f._b = true;
      on(f, 'submit', function (e) {
        e.preventDefault(); var inp = $('input', f); var msg = f.nextElementSibling && f.nextElementSibling.matches('[data-coupon-msg]') ? f.nextElementSibling : null;
        applyCode(inp.value, msg);
      });
    });
    $$('[data-cart-note]').forEach(function (t) {
      if (t._b) return; t._b = true;
      on(t, 'input', function () { clearTimeout(noteT); noteT = setTimeout(function () { postJSON(root + 'cart/update.js', { note: t.value }); }, 500); });
    });
  }
  bindCartUI();

  /* cart cross-sell (recommendations) */
  var recCache = {};
  function loadCartRecs() {
    $$('[data-cart-recs]').forEach(function (box) {
      var url = box.getAttribute('data-cart-recs'), tr = $('[data-xsell-track]', box);
      if (!url || !tr || box._recs === url) return; box._recs = url;
      var lim = +tr.getAttribute('data-limit') || 6;
      var apply = function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html'), items = $$('.xitem', doc);
        var inCart = (cartState && cartState.items || []).map(function (i) { return String(i.product_id); });
        items = items.filter(function (it) { return inCart.indexOf(it.getAttribute('data-product-id')) < 0; });
        if (!items.length) return false;
        var have = {}; items.forEach(function (it) { have[it.getAttribute('data-product-id')] = 1; });
        // keep manual ones after the auto ones until limit
        $$('.xitem', tr).forEach(function (it) { if (!have[it.getAttribute('data-product-id')]) items.push(it); });
        tr.innerHTML = ''; items.slice(0, lim).forEach(function (it) { tr.appendChild(document.importNode(it, true)); });
        box.hidden = false; return true;
      };
      if (recCache[url]) { apply(recCache[url]); return; }
      fetch(url).then(function (r) { return r.ok ? r.text() : ''; }).then(function (html) {
        if (!html) return;
        if (!apply(html) && /intent=complementary/.test(url)) {
          var u2 = url.replace('intent=complementary', 'intent=related');
          return fetch(u2).then(function (r) { return r.ok ? r.text() : ''; }).then(function (h2) { if (h2) { recCache[url] = h2; apply(h2); } });
        }
        recCache[url] = html;
      }).catch(function () {});
    });
  }
  if ($('[data-cart-recs]')) getCart().then(loadCartRecs).catch(function () {});
  on(document, 'cart:updated', loadCartRecs);

  on(document, 'click', function (e) {
    var st = e.target.closest('[data-qty-step]');
    if (st) {
      var line = st.closest('[data-line-key]'); if (!line) return;
      var inp = $('[data-qty-input]', line); var q = Math.max(0, (+inp.value || 0) + (+st.getAttribute('data-qty-step')));
      inp.value = q; changeLine(line.getAttribute('data-line-key'), q); return;
    }
    var ls = e.target.closest('[data-line-set]');
    if (ls) { var l3 = ls.closest('[data-line-key]'); if (l3) { ls.classList.add('is-loading'); changeLine(l3.getAttribute('data-line-key'), +ls.getAttribute('data-line-set')); } return; }
    var xs = e.target.closest('[data-xsell-prev],[data-xsell-next]');
    if (xs) {
      var tr = $('[data-xsell-track]', xs.closest('.xsell')); if (!tr) return;
      var dir = xs.hasAttribute('data-xsell-next') ? 1 : -1, rtl = document.documentElement.dir === 'rtl';
      tr.scrollBy({ left: dir * (rtl ? -1 : 1) * tr.clientWidth * 0.8, behavior: 'smooth' }); return;
    }
    var rm = e.target.closest('[data-line-remove]');
    if (rm) { var l2 = rm.closest('[data-line-key]'); if (l2) changeLine(l2.getAttribute('data-line-key'), 0); return; }
    var cr = e.target.closest('[data-coupon-remove]');
    if (cr) {
      var code = cr.getAttribute('data-coupon-remove');
      getCart().then(function (c) {
        var keep = (c.discount_codes || []).map(function (d) { return d.code; }).filter(function (x) { return x !== code; });
        return postJSON(root + 'cart/update.js', { discount: keep.join(',') });
      }).then(function () { afterCartChange(false); });
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault(); e.stopPropagation();
      var id = +qa.getAttribute('data-quick-add'); if (!id) return;
      qa.classList.add('is-loading');
      addItems([{ id: id, quantity: 1 }], { open: !qa.hasAttribute('data-no-open') })
        .then(function () { if (qa.hasAttribute('data-no-open')) toast(S.added); })
        .finally(function () { qa.classList.remove('is-loading'); });
      return;
    }
    var ac = e.target.closest('[data-apply-code]');
    if (ac) { applyCode(ac.getAttribute('data-apply-code')); closePanels(); }
  });
  on(document, 'change', function (e) {
    var inp = e.target.closest('[data-qty-input]'); if (!inp) return;
    var line = inp.closest('[data-line-key]'); if (line) changeLine(line.getAttribute('data-line-key'), Math.max(0, +inp.value || 0));
  });

  getCart().then(function (c) { updateCounts(c); return syncGift(c).then(function (changed) { if (changed) renderCartSections(); }); }).catch(function () {});

  /* =========================================================
     WISHLIST + COMPARE
     ========================================================= */
  function listGet(k) { return store.get(k, []); }
  function listSet(k, v) { store.set(k, v); refreshLists(); }
  function refreshLists() {
    var w = listGet('wish'), c = listGet('cmp');
    $$('[data-wish-count]').forEach(function (el) { el.textContent = w.length || ''; el.setAttribute('data-count', w.length); });
    $$('[data-wish-toggle]').forEach(function (b) {
      var onn = w.indexOf(b.getAttribute('data-wish-toggle')) > -1; b.classList.toggle('is-on', onn);
      if (b.hasAttribute('data-label-on')) b.textContent = onn ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
      else b.innerHTML = onn ? '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>' : '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round"><path d="M12 20s-7-4.4-7-10a4 4 0 0 1 7-2.6A4 4 0 0 1 19 10c0 5.6-7 10-7 10z"/></svg>';
    });
    $$('[data-compare-toggle]').forEach(function (b) {
      var onn = c.indexOf(b.getAttribute('data-compare-toggle')) > -1; b.classList.toggle('is-on', onn);
      if (b.hasAttribute('data-label-on')) b.textContent = onn ? b.getAttribute('data-label-on') : b.getAttribute('data-label-off');
    });
    var bar = $('[data-compare-bar]');
    if (bar) { bar.hidden = !c.length || !!$('[data-compare-page]'); var cc = $('[data-compare-count]', bar); if (cc) cc.textContent = c.length; }
  }
  on(document, 'click', function (e) {
    var w = e.target.closest('[data-wish-toggle]');
    if (w) {
      e.preventDefault(); e.stopPropagation();
      var h = w.getAttribute('data-wish-toggle'), l = listGet('wish'), i = l.indexOf(h);
      if (i > -1) { l.splice(i, 1); toast(S.wishRemove); } else { l.unshift(h); toast(S.wishAdd); }
      listSet('wish', l); if (w.closest('[data-wishlist-page]')) renderWishlist(); return;
    }
    var c = e.target.closest('[data-compare-toggle]');
    if (c) {
      e.preventDefault(); e.stopPropagation();
      var h2 = c.getAttribute('data-compare-toggle'), l2 = listGet('cmp'), j = l2.indexOf(h2);
      if (j > -1) { l2.splice(j, 1); toast(S.cmpRemove); }
      else { if (l2.length >= (T.compareMax || 3)) { toast(S.cmpMax.replace('[n]', T.compareMax || 3)); return; } l2.push(h2); toast(S.cmpAdd); }
      listSet('cmp', l2); if (c.closest('[data-compare-page]')) renderCompare(); return;
    }
    if (e.target.closest('[data-compare-clear]')) listSet('cmp', []);
  });
  refreshLists();

  function fetchCard(handle, view) {
    return fetch(root + 'products/' + handle + '?view=' + (view || 'card')).then(function (r) { return r.ok ? r.text() : ''; });
  }
  function renderWishlist() {
    var page = $('[data-wishlist-page]'); if (!page) return;
    var grid = $('[data-wishlist-grid]', page), empty = $('[data-wishlist-empty]', page), cnt = $('[data-wishlist-total]', page);
    var l = listGet('wish'); if (cnt) cnt.textContent = l.length;
    empty.hidden = !!l.length; if (!l.length) { grid.innerHTML = ''; return; }
    Promise.all(l.map(function (h) { return fetchCard(h, 'card'); })).then(function (htmls) {
      grid.innerHTML = htmls.join(''); refreshLists();
    });
  }
  renderWishlist();

  function renderCompare() {
    var page = $('[data-compare-page]'); if (!page) return;
    var wrap = $('[data-compare-table]', page), empty = $('[data-compare-empty]', page);
    var l = listGet('cmp'); empty.hidden = !!l.length; wrap.hidden = !l.length; if (!l.length) return;
    Promise.all(l.map(function (h) { return fetch(root + 'products/' + h + '?view=compare').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (ps) {
        ps = ps.filter(Boolean);
        var rows = JSON.parse(page.getAttribute('data-rows') || '[]');
        var specKeys = [];
        if (page.hasAttribute('data-specs')) ps.forEach(function (p) { Object.keys(p.specs || {}).forEach(function (k) { if (specKeys.indexOf(k) < 0) specKeys.push(k); }); });
        var h = '<table><tr><th></th>' + ps.map(function (p) {
          return '<td><div class="cmp-prod"><a class="cmp-prod__img" href="' + p.url + '">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</a><b>' + esc(p.title) + '</b>' +
            (p.available ? '<button type="button" class="btn btn--ink btn--sm" data-quick-add="' + p.variant + '">' + esc(page.getAttribute('data-atc') || 'أضف للسلة') + '</button>' : '<span class="muted small">' + S.soldOut + '</span>') +
            '<button type="button" class="btn--link" data-compare-toggle="' + p.handle + '">' + esc(page.getAttribute('data-remove') || 'إزالة') + '</button></div></td>';
        }).join('') + '</tr>';
        rows.forEach(function (r) {
          h += '<tr><th>' + esc(r.label) + '</th>' + ps.map(function (p) { return '<td>' + (p[r.key] != null && p[r.key] !== '' ? p[r.key] : '—') + '</td>'; }).join('') + '</tr>';
        });
        specKeys.forEach(function (k) { h += '<tr><th>' + esc(k) + '</th>' + ps.map(function (p) { return '<td>' + esc((p.specs || {})[k] || '—') + '</td>'; }).join('') + '</tr>'; });
        wrap.innerHTML = h + '</table>';
      });
  }
  renderCompare();

  /* recently viewed */
  (function () {
    var pr = $('[data-product-root]');
    if (pr && T.recentOn) { var h = pr.getAttribute('data-handle'), l = listGet('recent').filter(function (x) { return x !== h; }); l.unshift(h); store.set('recent', l.slice(0, 12)); }
    var box = $('[data-recent]'); if (!box) return;
    var ex = box.getAttribute('data-exclude'), lim = +box.getAttribute('data-limit') || 6;
    var list = listGet('recent').filter(function (x) { return x && x !== ex; }).slice(0, lim);
    if (!list.length) return;
    Promise.all(list.map(function (h) { return fetchCard(h, 'mini'); })).then(function (htmls) {
      var html = htmls.join('').trim(); if (!html) return;
      $('[data-recent-list]', box).innerHTML = html; box.hidden = false;
    });
  })();

  /* related products (recommendations API) */
  $$('[data-related]').forEach(function (el) {
    if (el.children.length) return;
    fetch(el.getAttribute('data-url')).then(function (r) { return r.text(); }).then(function (t) {
      var d = new DOMParser().parseFromString(t, 'text/html'); var n = $('[data-related]', d);
      if (n && n.innerHTML.trim()) { el.innerHTML = n.innerHTML; refreshLists(); }
    }).catch(function () {});
  });

  /* =========================================================
     PREDICTIVE SEARCH
     ========================================================= */
  var SC = T.search || { on: true, limit: 6, collections: true, articles: true, queries: true, recent: true };
  function recentList() { return store.get('recent-search', []) || []; }
  function pushRecent(q) {
    q = (q || '').trim(); if (!q || !SC.recent) return;
    var l = recentList().filter(function (x) { return x.toLowerCase() !== q.toLowerCase(); });
    l.unshift(q); store.set('recent-search', l.slice(0, 8));
  }
  $$('[data-predictive-input]').forEach(function (inp) {
    var form = inp.closest('form'), out = $('[data-predictive-results]', form), pop = $('[data-search-popular]', form);
    var spin = $('[data-search-spin]', form), clr = $('[data-search-clear]', form), t, ctrl, cache = {}, sel = -1;
    function renderRecent() {
      var box = $('[data-search-recent]', form); if (!box) return;
      var l = recentList(); box.hidden = !l.length;
      $('[data-search-recent-list]', box).innerHTML = l.map(function (q) { return '<button type="button" class="chip chip--recent" data-search-term="' + esc(q) + '">' + esc(q) + '</button>'; }).join('');
    }
    renderRecent();
    on(form, 'click', function (e) {
      var term = e.target.closest('[data-search-term]');
      if (term) { inp.value = term.getAttribute('data-search-term'); inp.dispatchEvent(new Event('input')); inp.focus(); return; }
      if (e.target.closest('[data-search-recent-clear]')) { store.set('recent-search', []); renderRecent(); return; }
      if (e.target.closest('[data-search-clear]')) { inp.value = ''; inp.dispatchEvent(new Event('input')); inp.focus(); return; }
      if (e.target.closest('[data-ps-item]') || e.target.closest('.psr__link')) pushRecent(inp.value);
    });
    on(form, 'submit', function (e) {
      var items = $$('[data-ps-item]', out);
      if (sel >= 0 && items[sel]) { e.preventDefault(); pushRecent(inp.value); window.location.href = items[sel].href; return; }
      if (!inp.value.trim()) { e.preventDefault(); return; }
      pushRecent(inp.value);
    });
    on(inp, 'keydown', function (e) {
      var items = $$('[data-ps-item]', out); if (!items.length) return;
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        sel = e.key === 'ArrowDown' ? Math.min(items.length - 1, sel + 1) : Math.max(-1, sel - 1);
        items.forEach(function (it, i) { it.classList.toggle('is-sel', i === sel); });
        if (items[sel]) items[sel].scrollIntoView({ block: 'nearest' });
      }
    });
    function show(html) { out.innerHTML = html; sel = -1; inp.setAttribute('aria-expanded', html ? 'true' : 'false'); }
    function jsonFallback(q) {
      return fetchJSON(root + 'search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=' + SC.limit + '&resources[options][unavailable_products]=last')
        .then(function (res) {
          var r = res.resources.results, h = '';
          if (r.products && r.products.length) h += '<div class="ps__group"><div class="ps__hd"><b>منتجات</b></div><div class="ps__products">' + r.products.map(function (p) {
            return '<div class="psr"><a class="psr__link" data-ps-item href="' + p.url + '"><span class="psr__img">' + (p.image ? '<img src="' + p.image + '" alt="" loading="lazy">' : '') + '</span><span class="psr__txt"><span class="psr__title">' + esc(p.title) + '</span><span class="psr__price"><b>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</b></span></span></a></div>';
          }).join('') + '</div></div>';
          if (r.collections && r.collections.length) h += '<div class="ps__group"><div class="ps__cols">' + r.collections.map(function (c) { return '<a class="ps__col" data-ps-item href="' + c.url + '"><span>' + esc(c.title) + '</span></a>'; }).join('') + '</div></div>';
          if (!h) h = '<div class="ps__empty"><b>مفيش نتايج لـ "' + esc(q) + '"</b></div>';
          else h += '<a class="btn btn--ink btn--block ps__all" data-ps-item href="' + R.search + '?q=' + encodeURIComponent(q) + '">شوف كل النتايج ←</a>';
          return h;
        });
    }
    on(inp, 'input', function () {
      clearTimeout(t); var q = inp.value.trim();
      if (clr) clr.hidden = !inp.value;
      if (!q) { show(''); if (pop) pop.hidden = false; renderRecent(); if (spin) spin.hidden = true; return; }
      if (SC.on === false) return;
      t = setTimeout(function () {
        if (cache[q]) { if (pop) pop.hidden = true; show(cache[q]); return; }
        if (ctrl && ctrl.abort) ctrl.abort();
        ctrl = window.AbortController ? new AbortController() : null;
        if (spin) spin.hidden = false;
        var types = ['product']; if (SC.collections) types.push('collection'); if (SC.articles) types.push('article'); if (SC.pages) types.push('page'); if (SC.queries) types.push('query');
        var url = (R.predictive || root + 'search/suggest') + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=' + types.join(',') +
          '&resources[limit]=' + SC.limit + '&resources[limit_scope]=each&resources[options][unavailable_products]=last' +
          (SC.deep ? '&resources[options][fields]=title,product_type,variants.title,vendor,tag,body' : '');
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html'), res = $('[data-ps-results]', doc);
          if (!res) throw 0;
          return res.innerHTML;
        }).catch(function (err) { if (err && err.name === 'AbortError') throw err; return jsonFallback(q); }).then(function (h) {
          if (inp.value.trim() !== q) return;
          cache[q] = h; if (pop) pop.hidden = true; show(h);
        }).catch(function () {}).then(function () { if (spin && inp.value.trim() === q) spin.hidden = true; });
      }, 180);
    });
  });
  $$('[data-search-page]').forEach(function (f) {
    var i = $('input[name=q]', f); if (i && i.value) pushRecent(i.value);
    on(f, 'submit', function () { pushRecent(i.value); });
  });
  // focus search on "/" key
  on(document, 'keydown', function (e) {
    if (e.key === '/' && !/input|textarea|select/i.test((document.activeElement || {}).tagName || '') && $('[data-panel="search"]')) { e.preventDefault(); openPanel('search'); }
  });

  /* =========================================================
     POPUPS
     ========================================================= */
  function canShow(key, days) { var t = store.get('pop-' + key, 0); return !t || (days > 0 && Date.now() - t > days * 86400000); }
  function markShown(key) { store.set('pop-' + key, Date.now()); }
  function openModal(m) { $$('.modal.is-open').forEach(function (x) { x.classList.remove('is-open'); }); m.classList.add('is-open'); document.body.classList.add('lock'); }
  var isMob = window.matchMedia('(max-width: 749px)').matches;
  var anyOpen = function () { return !!$('.modal.is-open, [data-panel].is-open'); };
  (function () {
    var m = $('[data-popup="welcome"]'); if (!m) return;
    var days = +m.getAttribute('data-days') || 0;
    if (location.hash === '#WelcomePopup' || /contact_posted|customer_posted/.test(location.search)) { if (location.hash === '#WelcomePopup') { openModal(m); return; } }
    if (m.getAttribute('data-design') === 'true') return;
    if (isMob && m.getAttribute('data-mobile') !== 'true') return;
    if (!canShow('welcome', days)) return;
    setTimeout(function () { if (anyOpen()) return; openModal(m); markShown('welcome'); }, (+m.getAttribute('data-delay') || 6) * 1000);
  })();
  (function () {
    var m = $('[data-popup="exit"]'); if (!m) return;
    var days = +m.getAttribute('data-days') || 0, shown = false;
    var show = function () { if (shown || anyOpen() || !canShow('exit', days)) return; shown = true; openModal(m); markShown('exit'); };
    if (isMob) { if (m.getAttribute('data-mobile') === 'true') setTimeout(show, (+m.getAttribute('data-mobile-delay') || 40) * 1000); }
    else on(document, 'mouseout', function (e) { if (!e.relatedTarget && e.clientY <= 4) show(); });
  })();

  /* sales pop */
  (function () {
    var el = $('[data-sales-pop]'); if (!el) return;
    var data; try { data = JSON.parse($('[data-spop-data]', el).textContent); } catch (e) { return; }
    var names = (data.names || []).map(function (s) { return s.trim(); }).filter(Boolean), prods = data.products || [];
    if (!names.length || !prods.length) return;
    var iv = (+el.getAttribute('data-interval') || 15) * 1000, dur = (+el.getAttribute('data-duration') || 6) * 1000;
    var mn = +el.getAttribute('data-min') || 2, mx = +el.getAttribute('data-max') || 10, i = 0, stopped = false;
    on($('[data-spop-close]', el), 'click', function () { stopped = true; el.classList.remove('is-on'); });
    var show = function () {
      if (stopped || anyOpen()) return;
      var p = prods[i % prods.length], n = names[i % names.length]; i++;
      $('[data-spop-title]', el).textContent = (data.template || '[name] اشترى [product]').replace('[name]', n).replace('[product]', p.t);
      $('[data-spop-ago]', el).textContent = (data.ago || 'منذ [n] دقايق').replace('[n]', mn + Math.floor(Math.random() * (mx - mn + 1)));
      $('[data-spop-img]', el).src = p.i || ''; $('[data-spop-link]', el).href = p.u;
      el.classList.add('is-on'); setTimeout(function () { el.classList.remove('is-on'); }, dur);
    };
    setTimeout(function () { show(); setInterval(show, iv); }, 8000);
  })();

  /* =========================================================
     PRODUCT PAGE
     ========================================================= */
  function initProduct(rootEl) {
    var isQuick = rootEl.hasAttribute('data-quick-root');
    var data; try { data = JSON.parse($('[data-product-json]', rootEl).textContent); } catch (e) { return; }
    var variants = data.variants || [];
    var form = $('[data-product-form]', rootEl);
    var vInputs = $$('[data-variant-input]', rootEl);
    var state = { variant: variants.filter(function (v) { return String(v.id) === (vInputs[0] && vInputs[0].value); })[0] || variants[0], tier: { index: 0, qty: 1, pct: 0, label: '' }, qty: 1 };

    /* gallery */
    var slides = $('[data-gal-slides]', rootEl), thumbs = $$('[data-gal-thumb]', rootEl), dots = $$('.pgal__dots span', rootEl), pos = $('[data-gal-pos]', rootEl);
    function setActive(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      if (pos) pos.textContent = i + 1;
    }
    function goTo(i) { if (!slides) return; var s = slides.children[i]; if (!s) return; slides.scrollTo({ left: s.offsetLeft - slides.offsetLeft, behavior: 'smooth' }); setActive(i); }
    thumbs.forEach(function (t) { on(t, 'click', function () { goTo(+t.getAttribute('data-gal-thumb')); }); });
    if (slides) on(slides, 'scroll', function () { var i = Math.round(Math.abs(slides.scrollLeft) / slides.clientWidth); setActive(i); }, { passive: true });

    /* tiers */
    var tierEls = $$('[data-tier]', rootEl);
    function readTier(el, idx) { return { index: idx, qty: +el.getAttribute('data-qty') || 1, pct: +el.getAttribute('data-pct') || 0, label: el.getAttribute('data-label') || '' }; }
    function selectTier(i, silent) {
      if (!tierEls.length) return;
      i = Math.max(0, Math.min(tierEls.length - 1, i));
      tierEls.forEach(function (t, k) { t.classList.toggle('is-on', k === i); var r = $('input', t); if (r) r.checked = k === i; });
      state.tier = readTier(tierEls[i], i);
      if (!silent) update();
    }
    tierEls.forEach(function (t, k) { on(t, 'click', function (e) { e.preventDefault(); selectTier(k); }); });
    if (tierEls.length) { var tb = $('[data-tiers]', rootEl); selectTier(+(tb && tb.getAttribute('data-default')) || 0, true); }

    /* plain qty */
    var pq = $('[data-pqty-input]', rootEl);
    $$('[data-pqty]', rootEl).forEach(function (b) { on(b, 'click', function () { pq.value = Math.max(1, (+pq.value || 1) + (+b.getAttribute('data-pqty'))); update(); }); });
    if (pq) on(pq, 'change', update);

    /* family */
    var fam = $('[data-family]', rootEl);
    if (fam) $$('[data-fam-tier]', fam).forEach(function (b) {
      on(b, 'click', function () {
        $$('[data-fam-tier]', fam).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        var o = $('[data-fam-out]', fam); o.hidden = false; o.textContent = '✓ ' + b.getAttribute('data-fam-msg');
        selectTier(+b.getAttribute('data-fam-tier') || 0);
      });
    });

    /* addons / wrap */
    $$('[data-addon]', rootEl).forEach(function (a) { var i = $('input', a); on(i, 'change', function () { a.classList.toggle('is-on', i.checked); update(); }); });
    var wrap = $('[data-wrap]', rootEl);
    if (wrap) { var wi = $('input', wrap); on(wi, 'change', function () { wrap.classList.toggle('is-on', wi.checked); update(); }); }

    /* variant picker */
    var picker = $('[data-variant-picker]', rootEl);
    function currentOptions() {
      var opts = [];
      if (!picker) return state.variant ? state.variant.options : [];
      (data.options || []).forEach(function (_, i) {
        var sel = $('select[data-opt-index="' + i + '"]', picker);
        if (sel) opts[i] = sel.value;
        else { var r = $('input[data-opt-index="' + i + '"]:checked', picker); opts[i] = r ? r.value : null; }
      });
      return opts;
    }
    if (picker) on(picker, 'change', function () {
      var opts = currentOptions();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); })[0];
      opts.forEach(function (o, i) { var l = $('[data-opt-label="' + i + '"]', picker); if (l) l.textContent = o; });
      if (v) {
        state.variant = v;
        vInputs.forEach(function (inp) { inp.value = v.id; });
        if (v.featured_media && slides) { var s = $('[data-media-id="' + v.featured_media.id + '"]', slides); if (s) goTo(+s.getAttribute('data-index')); }
        if (!isQuick && window.history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); }
      }
      // availability marks
      $$('input[data-opt-index]', picker).forEach(function (inp) {
        var idx = +inp.getAttribute('data-opt-index'); var test = opts.slice(); test[idx] = inp.value;
        var ok = variants.some(function (x) { return x.available && x.options.every(function (o, i) { return o === test[i]; }); });
        inp.parentNode.classList.toggle('is-unavailable', !ok);
      });
      update();
    });

    /* computed values */
    function calc() {
      var v = state.variant || {}; var t = state.tier;
      var qty = tierEls.length ? t.qty : (pq ? Math.max(1, +pq.value || 1) : 1);
      var pct = tierEls.length ? t.pct : 0;
      var unit = v.price || 0;
      var mainTotal = Math.round(unit * qty * (100 - pct) / 100);
      var cmpUnit = Math.max(v.compare_at_price || 0, unit);
      var extras = 0;
      $$('[data-addon-input]:checked', rootEl).forEach(function (i) { extras += +i.getAttribute('data-price') || 0; });
      var w = $('[data-wrap-input]:checked', rootEl); if (w) extras += +w.getAttribute('data-price') || 0;
      return { v: v, qty: qty, pct: pct, unit: unit, cmpUnit: cmpUnit, mainTotal: mainTotal, cmpTotal: cmpUnit * qty, total: mainTotal + extras };
    }

    function update() {
      var c = calc(), v = c.v;
      // price block
      var pEl = $('[data-price]', rootEl); if (pEl) { pEl.textContent = formatMoney(v.price); pEl.classList.toggle('pprice__now--reg', !(v.compare_at_price > v.price)); }
      var cEl = $('[data-compare-price]', rootEl); if (cEl) { cEl.hidden = !(v.compare_at_price > v.price); cEl.textContent = formatMoney(v.compare_at_price); }
      var sv = $('[data-save]', rootEl); if (sv) { sv.hidden = !(v.compare_at_price > v.price); var sa = $('[data-save-amount]', sv); if (sa) sa.textContent = formatMoney((v.compare_at_price || 0) - v.price); }
      var sb = $('[data-save-badge]', rootEl); if (sb) { var pc = v.compare_at_price > v.price ? Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) : 0; sb.hidden = !pc; sb.textContent = sb.textContent.replace(/\d+%/, pc + '%'); }
      var pd = $('[data-per-day]', rootEl);
      if (pd) { var days = (+pd.getAttribute('data-days') || 30) * c.qty; pd.innerHTML = esc(pd.getAttribute('data-template')).replace('[amount]', '<b>' + formatMoney(c.mainTotal / days) + '</b>'); }
      // tiers prices
      tierEls.forEach(function (t) {
        var q = +t.getAttribute('data-qty') || 1, p = +t.getAttribute('data-pct') || 0;
        var tot = Math.round(v.price * q * (100 - p) / 100), cmp = c.cmpUnit * q;
        var a = $('[data-tier-total]', t), b = $('[data-tier-compare]', t);
        if (a) a.textContent = formatMoney(tot); if (b) { b.textContent = formatMoney(cmp); b.hidden = cmp <= tot; }
        var un = $('[data-tier-unit]', t); if (un) un.textContent = q > 1 ? 'القطعة بـ ' + formatMoney(Math.round(tot / q)) : '';
      });
      // atc
      $$('[data-atc]', rootEl).forEach(function (btn) {
        btn.disabled = !v.available;
        var l = $('[data-atc-label]', btn);
        if (l) l.textContent = v.available ? btn.getAttribute('data-text').replace('[price]', formatMoney(c.total)) : btn.getAttribute('data-soldout');
      });
      $$('[data-buy-now]', rootEl).forEach(function (b) { b.disabled = !v.available; });
      // quick order
      var qs = $('[data-qo-summary]', rootEl); if (qs) qs.textContent = (state.tier.label || (c.qty + ' ×')) + (v.title && v.title !== 'Default Title' ? ' · ' + v.title : '');
      var qp = $('[data-qo-price]', rootEl); if (qp) qp.textContent = formatMoney(c.total);
      // ship progress
      var spb = $('[data-ship-progress]', rootEl);
      if (spb) {
        var at = +spb.getAttribute('data-at') * (T.currencyRate || 1), fq = +spb.getAttribute('data-free-qty') || 0;
        var after = (cartState ? cartState.total_price : 0) + c.total;
        var done = (fq && c.qty >= fq) || (at && after >= at);
        $('[data-ship-msg]', spb).textContent = done ? spb.getAttribute('data-done') : spb.getAttribute('data-msg').replace('[amount]', formatMoney(Math.max(0, at - after)));
        $('[data-ship-bar]', spb).style.setProperty('--w', (done ? 100 : Math.min(100, after / (at || 1) * 100)) + '%');
      }
      var detail = { variant: v, tier: state.tier, qty: c.qty, total: c.total, mainTotal: c.mainTotal, cmpUnit: c.cmpUnit, tierCount: tierEls.length, tiers: tierEls.map(readTier) };
      state.last = detail;
      $$('[data-qty-hidden]', rootEl).forEach(function (inp) { inp.value = c.qty; });
      if (!isQuick) document.dispatchEvent(new CustomEvent('product:update', { detail: detail }));
    }

    function buildItems() {
      var c = calc(), items = [];
      var props = {};
      if (tierEls.length && state.tier.label) props._offer = state.tier.label;
      items.push({ id: c.v.id, quantity: c.qty, properties: props });
      $$('[data-addon-input]:checked', rootEl).forEach(function (i) { items.push({ id: +i.value, quantity: 1, properties: { _addon: data.title } }); });
      var w = $('[data-wrap-input]:checked', rootEl);
      if (w) {
        var wp = {}; var to = $('[data-wrap-to]', rootEl), msg = $('[data-wrap-msg]', rootEl), fr = $('[data-wrap-from]', rootEl);
        if (to && to.value) wp['إلى'] = to.value; if (msg && msg.value) wp['الرسالة'] = msg.value; if (fr && fr.value) wp['من'] = fr.value;
        items.push({ id: +w.value, quantity: 1, properties: wp });
      }
      return items;
    }
    function doAdd(btn, buyNow) {
      if (btn) btn.classList.add('is-loading');
      return addItems(buildItems(), { open: !buyNow }).then(function () {
        if (buyNow) window.location.href = root + 'checkout';
      }).catch(function () {}).finally(function () { if (btn) btn.classList.remove('is-loading'); });
    }
    function codItems() {
      var c = calc(), v = c.v, fi = data.featured_image, img = (v.featured_image && v.featured_image.src) || (fi && (fi.src || fi)) || '';
      img = typeof img === 'string' ? img : '';
      if (img && img.indexOf('//') === 0) img = 'https:' + img;
      var items = [{ variant_id: v.id, quantity: c.qty, pct: (state.tier && state.tier.pct) || 0, title: data.title, variant: v.title && v.title !== 'Default Title' ? v.title : '', image: img, price: v.price }];
      $$('[data-addon-input]:checked', rootEl).forEach(function (i) { items.push({ variant_id: +i.value, quantity: 1, pct: +i.getAttribute('data-pct') || 0, title: i.getAttribute('data-title') || '', image: i.getAttribute('data-img') || '', price: +i.getAttribute('data-base') || +i.getAttribute('data-price') || 0 }); });
      var w = $('[data-wrap-input]:checked', rootEl), note = '';
      if (w) {
        items.push({ variant_id: +w.value, quantity: 1, pct: 0, title: w.getAttribute('data-title') || 'تغليف هدية', image: '', price: +w.getAttribute('data-price') || 0 });
        var to = $('[data-wrap-to]', rootEl), msg = $('[data-wrap-msg]', rootEl), fr = $('[data-wrap-from]', rootEl);
        note = ['هدية', to && to.value ? 'إلى: ' + to.value : '', msg && msg.value ? 'الرسالة: ' + msg.value : '', fr && fr.value ? 'من: ' + fr.value : ''].filter(Boolean).join(' - ');
      }
      return { items: items, single: true, source: isQuick ? 'quick' : 'product', offer: (state.tier && state.tier.label) || '', extraNote: note };
    }
    function openCod() { return T.codOpen && T.codOpen(codItems()); }
    var CFp = T.codf || {};
    $$('[data-atc]', rootEl).forEach(function (b) { if (!b.closest('[data-cod-form]') && !b.hasAttribute('data-es-btn')) on(b, 'click', function () { if (CFp.on && CFp.replaceAtc && openCod()) return; doAdd(b); }); });
    var esUrl = (data.url || ('/products/' + data.handle)) + '?es=1';
    $$('[data-cod-open]', rootEl).forEach(function (b) { if (b.getAttribute('data-cod-open') !== 'cart') on(b, 'click', function (e) { e.preventDefault(); if (T.esOpen && T.esOpen('product', isQuick ? esUrl : null, { tier: state.tier ? state.tier.index : -1 })) return; if (!openCod()) doAdd(b, true); }); });
    var inlineCod = $('[data-codf][data-mode="inline"]', rootEl);
    if (inlineCod && T.codfInitBox) {
      inlineCod._provider = function () { var o = codItems(); o.source = 'product-inline'; return o; };
      T.codfInitBox(inlineCod);
      inlineCod._st = Object.assign(inlineCod._provider(), { opened: Date.now() });
      document.addEventListener('product:update', function () { inlineCod._st = Object.assign(inlineCod._st || {}, inlineCod._provider()); T.codfRender(inlineCod); });
      T.codfRender(inlineCod);
    }
    // COD app mode: standard Shopify form — let the app intercept first; if nobody did, add via AJAX
    $$('[data-cod-form]', rootEl).forEach(function (f) {
      on(document, 'submit', function (e) {
        if (e.target !== f || e.defaultPrevented) return;
        e.preventDefault(); doAdd($('[data-atc]', f));
      });
    });
    $$('[data-buy-now]', rootEl).forEach(function (b) { on(b, 'click', function () { if (T.esOpen && T.esOpen('product', isQuick ? (data.url || '/products/' + data.handle) + '?es=1' : null)) return; doAdd(b, true); }); });
    if (!isQuick) on(document, 'click', function (e) {
      var t = e.target.closest('[data-trigger-atc]'); if (!t) return;
      if (CFp.on && CFp.replaceAtc && openCod()) return;
      if (CFp.easysell && CFp.esMode === 'atc') { var eb = $('[data-es-btn]'); if (eb) { eb.click(); return; } }
      doAdd(t);
    });
    if (form) on(form, 'submit', function (e) { e.preventDefault(); doAdd(); });

    /* quick COD order → checkout prefilled */
    var qo = $('[data-quick-order]', rootEl);
    if (qo) {
      var ob = $('[data-qo-open]', qo); if (ob) on(ob, 'click', function () { $('[data-qo-body]', qo).hidden = false; ob.parentNode.hidden = true; });
      on(qo, 'submit', function (e) {
        e.preventDefault();
        var fd = new FormData(qo), items = buildItems();
        var perm = items.map(function (i) { return i.id + ':' + i.quantity; }).join(',');
        var p = new URLSearchParams();
        var name = (fd.get('first_name') || '').trim().split(/\s+/);
        p.set('checkout[shipping_address][first_name]', name.shift() || '');
        p.set('checkout[shipping_address][last_name]', name.join(' ') || '-');
        p.set('checkout[shipping_address][phone]', fd.get('phone') || '');
        p.set('checkout[shipping_address][address1]', fd.get('address1') || '');
        p.set('checkout[shipping_address][city]', fd.get('city') || fd.get('province') || '');
        p.set('checkout[shipping_address][province]', fd.get('province') || '');
        p.set('checkout[shipping_address][country]', 'EG');
        var dc = qo.getAttribute('data-discount'); if (dc) p.set('discount', dc);
        var btn = $('button[type=submit]', qo); if (btn) btn.classList.add('is-loading');
        window.location.href = root + 'cart/' + perm + '?' + p.toString();
      });
    }

    /* sticky ATC */
    var satc = isQuick ? null : $('[data-sticky-atc]');
    if (satc) {
      document.body.classList.add('has-sticky-atc');
      var anchor = $('[data-atc]', rootEl) || rootEl;
      var obs = new IntersectionObserver(function (en) { satc.classList.toggle('is-on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); });
      obs.observe(anchor);
    }

    update();
  }
  setTimeout(function () { $$('[data-product-root]').forEach(initProduct); }, 0);

  /* =========================================================
     INTERNAL COD FORM (فورم الطلب الداخلي)
     ========================================================= */
  var CF = T.codf || {};
  // UTM capture
  (function () {
    try {
      var q = new URLSearchParams(location.search), u = JSON.parse(sessionStorage.getItem('nahr:utm') || '{}'), hit = false;
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'fbclid', 'ttclid'].forEach(function (k) { var v = q.get(k); if (v) { u[k] = v.slice(0, 120); hit = true; } });
      if (hit) sessionStorage.setItem('nahr:utm', JSON.stringify(u));
    } catch (e) {}
  })();
  function utm() { try { return JSON.parse(sessionStorage.getItem('nahr:utm') || '{}'); } catch (e) { return {}; } }
  function tierFor(qty) { var p = 0; (CF.tiers || []).forEach(function (t) { if (t.qty && qty >= t.qty && t.pct > p) p = t.pct; }); return p; }
  function normPhone(s) {
    var p = String(s || '').replace(/[٠-٩]/g, function (d) { return '٠١٢٣٤٥٦٧٨٩'.indexOf(d); }).replace(/[^\d+]/g, '');
    p = p.replace(/^\+?0020/, '0').replace(/^\+20/, '0').replace(/^20(?=1\d{9}$)/, '0');
    if (/^1[0125]\d{8}$/.test(p)) p = '0' + p;
    return /^01[0125]\d{8}$/.test(p) ? p : '';
  }
  // pixels (lazy)
  var pxLoaded = false;
  function loadPixels() {
    if (pxLoaded) return; pxLoaded = true;
    var P = CF.pixels || {};
    try {
      if (P.meta && !window.fbq) {
        !function (f, b, e, v, n, t, s) { if (f.fbq) return; n = f.fbq = function () { n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments); }; if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0; t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s); }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      }
      if (P.meta && window.fbq) window.fbq('init', P.meta);
      if (P.tiktok && !window.ttq) {
        !function (w, d, t) { w.TiktokAnalyticsObject = t; var ttq = w[t] = w[t] || []; ttq.methods = ['page', 'track', 'identify', 'instances', 'debug', 'on', 'off', 'once', 'ready', 'alias', 'group', 'enableCookie', 'disableCookie']; ttq.setAndDefer = function (t, e) { t[e] = function () { t.push([e].concat(Array.prototype.slice.call(arguments, 0))); }; }; for (var i = 0; i < ttq.methods.length; i++) ttq.setAndDefer(ttq, ttq.methods[i]); ttq.load = function (e) { var n = 'https://analytics.tiktok.com/i18n/pixel/events.js'; ttq._i = ttq._i || {}; ttq._i[e] = []; ttq._i[e]._u = n; ttq._t = ttq._t || {}; ttq._t[e] = +new Date(); var o = d.createElement('script'); o.type = 'text/javascript'; o.async = !0; o.src = n + '?sdkid=' + e + '&lib=' + t; var a = d.getElementsByTagName('script')[0]; a.parentNode.insertBefore(o, a); }; ttq.load(P.tiktok); }(window, document, 'ttq');
      }
      if (P.snap && !window.snaptr) {
        (function (e, t, n) { if (e.snaptr) return; var a = e.snaptr = function () { a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments); }; a.queue = []; var s = 'script', r = t.createElement(s); r.async = !0; r.src = n; var u = t.getElementsByTagName(s)[0]; u.parentNode.insertBefore(r, u); })(window, document, 'https://sc-static.net/scevent.min.js');
        window.snaptr('init', P.snap);
      }
    } catch (e) {}
  }
  function track(kind, d) {
    loadPixels();
    var cur = CF.currency || 'EGP', ids = d.items.map(function (i) { return String(i.variant_id); }), num = d.items.reduce(function (a, i) { return a + i.quantity; }, 0);
    var val = Math.round(d.total) / 100;
    try {
      if (window.fbq) kind === 'start'
        ? window.fbq('track', 'InitiateCheckout', { value: val, currency: cur, content_ids: ids, content_type: 'product', num_items: num })
        : window.fbq('track', 'Purchase', { value: val, currency: cur, content_ids: ids, content_type: 'product', num_items: num }, { eventID: 'cod_' + d.order_id });
    } catch (e) {}
    try {
      if (window.ttq) window.ttq.track(kind === 'start' ? 'InitiateCheckout' : 'CompletePayment', { value: val, currency: cur, content_type: 'product', contents: d.items.map(function (i) { return { content_id: String(i.variant_id), quantity: i.quantity, price: i.price / 100 }; }) }, kind === 'start' ? undefined : { event_id: 'cod_' + d.order_id });
    } catch (e) {}
    try { if (window.snaptr) window.snaptr('track', kind === 'start' ? 'START_CHECKOUT' : 'PURCHASE', { price: val, currency: cur, item_ids: ids, number_items: num, transaction_id: d.order_id }); } catch (e) {}
    try {
      if (window.gtag) window.gtag('event', kind === 'start' ? 'begin_checkout' : 'purchase', { transaction_id: d.order_id, value: val, currency: cur, items: d.items.map(function (i) { return { item_id: String(i.variant_id), item_name: i.title, quantity: i.quantity, price: i.price / 100 }; }) });
    } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(kind === 'start' ? 'cod_form_open' : 'cod_form_purchase', { order: d.order_name, value: val, currency: cur, items: ids }); } catch (e) {}
  }

  function codfCalc(st, form) {
    var sub = 0, disc = 0;
    st.items.forEach(function (i) { var l = i.price * i.quantity; sub += l; disc += Math.round(l * (i.pct || 0) / 100); });
    var gsel = form && $('[data-codf-gov]', form), opt = gsel && gsel.selectedOptions && gsel.selectedOptions[0];
    var ship = null;
    if (opt && opt.value) { ship = Math.round((parseFloat(opt.getAttribute('data-fee')) || 0) * 100); if (CF.freeAt && sub - disc >= CF.freeAt) ship = 0; }
    return { sub: sub, disc: disc, ship: ship, total: sub - disc + (ship || 0) };
  }
  function codfRender(box) {
    var st = box._st; if (!st) return;
    var form = $('[data-codf-form]', box);
    var list = $('[data-codf-items]', box);
    if (list) list.innerHTML = box.getAttribute('data-mode') === 'inline' ? '' : st.items.map(function (i) {
      var line = i.price * i.quantity, after = Math.round(line * (100 - (i.pct || 0)) / 100);
      return '<div class="codf__item">' + (i.image ? '<img src="' + esc(i.image) + '" alt="" loading="lazy">' : '<span class="codf__noimg"></span>') +
        '<span class="codf__it"><b>' + esc(i.title) + '</b>' + (i.variant ? '<small>' + esc(i.variant) + '</small>' : '') + '</span>' +
        '<span class="codf__iq">×' + i.quantity + '</span><span class="codf__ip"><b>' + formatMoney(after) + '</b>' + (after < line ? '<s>' + formatMoney(line) + '</s>' : '') + '</span></div>';
    }).join('');
    // tiers inside popup (single product)
    var tw = $('[data-codf-tiers]', box);
    if (tw) {
      var show = st.single && CF.tiersOn && (CF.tiers || []).filter(function (t) { return t.label; }).length > 1 && box.getAttribute('data-mode') !== 'inline';
      tw.hidden = !show;
      if (show) {
        var main = st.items[0];
        tw.innerHTML = CF.tiers.map(function (t, idx) {
          if (!t.label) return '';
          var line = main.price * t.qty, after = Math.round(line * (100 - t.pct) / 100), on = main.quantity === t.qty;
          return '<button type="button" class="codf__tier' + (on ? ' is-on' : '') + '" data-codf-tier="' + idx + '"><span class="radio" aria-hidden="true"></span><span class="codf__tl"><b>' + esc(t.label) + '</b></span><span class="codf__tp"><b>' + formatMoney(after) + '</b>' + (after < line ? '<s>' + formatMoney(line) + '</s>' : '') + '</span>' + (CF.hot && idx === CF.hotIndex ? '<em class="codf__hot">' + esc(CF.hot) + '</em>' : '') + '</button>';
        }).join('');
      }
    }
    var c = codfCalc(st, form);
    var set = function (sel, v) { var e = $(sel, box); if (e) e.textContent = v; };
    set('[data-codf-subtotal]', formatMoney(c.sub));
    var dr = $('[data-codf-disc-row]', box); if (dr) dr.hidden = !c.disc;
    set('[data-codf-discount]', '−' + formatMoney(c.disc));
    set('[data-codf-ship]', c.ship === null ? (CF.shipPending || '—') : (c.ship === 0 ? (CF.freeText || 'مجاني') : formatMoney(c.ship)));
    set('[data-codf-total]', formatMoney(c.total));
    var btn = $('[data-codf-submit]', box), lb = btn && $('[data-codf-submit-label]', btn);
    if (lb) lb.textContent = (btn.getAttribute('data-text') || '').replace('[total]', formatMoney(c.total));
  }
  function codfSetItems(box, opts) {
    box._st = { items: opts.items || [], single: !!opts.single, source: opts.source || 'product', offer: opts.offer || '', extraNote: opts.extraNote || '', opened: box._st && box._st.opened || Date.now() };
    codfRender(box);
  }
  function codfPrefill(box) {
    if (!CF.remember) return;
    var saved = store.get('codf-customer', null), form = $('[data-codf-form]', box); if (!saved || !form) return;
    ['name', 'phone', 'phone2', 'governorate', 'city', 'address'].forEach(function (k) { var el = form.elements[k]; if (el && !el.value && saved[k]) el.value = saved[k]; });
  }
  function codfInitBox(box) {
    if (box._b) return; box._b = true;
    var form = $('[data-codf-form]', box);
    codfPrefill(box);
    on(box, 'click', function (e) {
      var t = e.target.closest('[data-codf-tier]'); if (!t || !box._st) return;
      var tier = CF.tiers[+t.getAttribute('data-codf-tier')]; if (!tier) return;
      box._st.items[0].quantity = tier.qty; box._st.items[0].pct = tier.pct; box._st.offer = tier.label;
      codfRender(box);
    });
    on(form, 'change', function (e) { if (e.target.matches('[data-codf-gov]')) codfRender(box); });
    on(form, 'input', function (e) { var er = $('[data-err="' + e.target.name + '"]', form); if (er) er.textContent = ''; e.target.classList.remove('is-err'); });
    on(form, 'submit', function (e) {
      e.preventDefault();
      if (box._busy) return;
      if (box._provider) box._st = Object.assign({}, box._st || {}, box._provider());
      var st = box._st; if (!st || !st.items.length) return;
      var f = form.elements, errs = {};
      var cust = { name: (f.name.value || '').trim(), phone: f.phone.value, phone2: f.phone2 ? f.phone2.value : '', governorate: f.governorate.value, city: f.city ? f.city.value.trim() : '', address: (f.address.value || '').trim(), notes: [f.notes ? f.notes.value.trim() : '', st.extraNote || ''].filter(Boolean).join(' | ') };
      if (cust.name.length < 2) errs.name = 'اكتب اسمك';
      if (!normPhone(cust.phone)) errs.phone = 'رقم الموبايل لازم يكون 11 رقم ويبدأ بـ 01';
      if (cust.phone2 && !normPhone(cust.phone2)) errs.phone2 = 'الرقم ده مش صحيح';
      if (!cust.governorate) errs.governorate = 'اختار المحافظة';
      if (cust.address.length < 5) errs.address = 'اكتب العنوان بالتفصيل';
      var showErrs = function (E) {
        var first = null;
        Object.keys(E).forEach(function (k) { var er = $('[data-err="' + k + '"]', form), inp = f[k]; if (er) er.textContent = E[k]; if (inp) { inp.classList.add('is-err'); first = first || inp; } });
        if (first) { first.focus(); first.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
      };
      if (Object.keys(errs).length) { showErrs(errs); return; }
      var c = codfCalc(st, form), msg = $('[data-codf-msg]', box), btn = $('[data-codf-submit]', box);
      msg.hidden = true; box._busy = true; btn.classList.add('is-loading'); btn.disabled = true;
      var payload = {
        items: st.items.map(function (i) { return { variant_id: i.variant_id, quantity: i.quantity, pct: i.pct || 0 }; }),
        customer: cust, shipping_fee: (c.ship || 0) / 100, offer: st.offer, source: st.source, utm: utm(),
        hp: f.website ? f.website.value : '', t: Date.now() - (st.opened || Date.now()), page: location.pathname
      };
      fetch(CF.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return { ok: false }; }); })
        .then(function (res) {
          if (!res.ok) {
            if (res.fields) showErrs(res.fields);
            msg.textContent = res.message || 'حصلت مشكلة — جرب تاني أو كلمنا واتساب'; msg.hidden = !!res.fields && !res.message;
            return;
          }
          if (CF.remember) store.set('codf-customer', { name: cust.name, phone: cust.phone, phone2: cust.phone2, governorate: cust.governorate, city: cust.city, address: cust.address });
          var total = res.total != null ? Math.round(res.total * 100) : c.total;
          track('purchase', { items: st.items, total: total, order_id: res.order_id || res.order_name, order_name: res.order_name });
          if (st.source === 'cart') postJSON(root + 'cart/clear.js', {}).then(renderCartSections).catch(function () {});
          if (CF.redirect) { window.location.href = CF.redirect + (CF.redirect.indexOf('?') > -1 ? '&' : '?') + 'order=' + encodeURIComponent(res.order_name || ''); return; }
          var done = $('[data-codf-done]', box), dt = $('[data-codf-done-text]', box);
          if (dt) dt.textContent = (dt.getAttribute('data-tpl') || '').replace('[order]', res.order_name || '');
          var ds = $('[data-codf-done-sum]', box); if (ds) ds.innerHTML = '<span>الإجمالي عند الاستلام</span><b>' + formatMoney(total) + '</b>';
          var wa = $('[data-codf-wa]', box);
          if (wa && CF.wa) wa.href = 'https://wa.me/' + CF.wa + '?text=' + encodeURIComponent('أهلاً، عايز أأكد طلبي رقم ' + (res.order_name || '') + ' باسم ' + cust.name);
          form.hidden = true; ['[data-codf-items]', '[data-codf-tiers]'].forEach(function (s) { var el = $(s, box); if (el) el.hidden = true; });
          var hd = $('.codf__hd', box); if (hd) hd.hidden = true;
          if (done) { done.hidden = false; done.scrollIntoView({ block: 'nearest' }); }
        })
        .catch(function () { msg.textContent = 'مفيش اتصال — اتأكد من النت وجرب تاني'; msg.hidden = false; })
        .finally(function () { box._busy = false; btn.classList.remove('is-loading'); btn.disabled = false; });
    });
  }
  function codfReset(box) {
    var form = $('[data-codf-form]', box); if (!form) return;
    form.hidden = false; ['[data-codf-items]', '.codf__hd'].forEach(function (s) { var el = $(s, box); if (el) el.hidden = false; });
    var d = $('[data-codf-done]', box); if (d) d.hidden = true;
    var m = $('[data-codf-msg]', box); if (m) m.hidden = true;
  }
  function codOpen(opts) {
    var box = $('[data-panel="cod"] [data-codf]');
    if (!CF.on || !box || !CF.endpoint) return false;
    codfInitBox(box); codfReset(box);
    box._st = null; codfSetItems(box, opts); box._st.opened = Date.now();
    openPanel('cod');
    var c = codfCalc(box._st, $('[data-codf-form]', box));
    track('start', { items: box._st.items, total: c.total });
    setTimeout(function () { var f = $('[data-codf-form] input[name=name]', box); if (f && !f.value && window.matchMedia('(min-width:750px)').matches) f.focus(); }, 250);
    return true;
  }
  T.codOpen = codOpen;
  // cart → COD form
  on(document, 'click', function (e) {
    var b = e.target.closest('[data-cod-open="cart"]'); if (!b) return;
    e.preventDefault();
    getCart().then(function (c) {
      var items = c.items.filter(function (it) { return !(it.properties && it.properties._gift); }).map(function (it) {
        return { variant_id: it.variant_id, quantity: it.quantity, pct: tierFor(it.quantity), title: it.product_title, variant: it.product_has_only_default_variant ? '' : it.variant_title, image: it.image, price: it.original_price };
      });
      if (!items.length) return;
      if (!codOpen({ items: items, source: 'cart' })) window.location.href = R.cart;
    });
  });
  $$('[data-codf][data-mode="inline"]').forEach(codfInitBox);
  T.codfRender = codfRender; T.codfInitBox = codfInitBox;

  /* ---------- EasySell bridge: أزرار الثيم بتفتح فورم EasySell، وزراير EasySell الأصلية بتستخبى ---------- */
  var ES = { found: false, prod: null, cart: null };
  function esIsNative(el) {
    if (!el || el.hasAttribute('data-es-btn') || el.classList.contains('es-popup-button-overwrite') || el.closest('.codf')) return false;
    var cls = el.getAttribute('class') || '', id = el.id || '';
    return /(^|\s)es[-_]/i.test(cls) || /^es[-_]/i.test(id);
  }
  function esScan() {
    var natives = $$('button, a, [role="button"], input[type="submit"], input[type="button"]').filter(function (el) {
      if (!esIsNative(el)) return false;
      // ignore buttons inside the EasySell popup/form itself
      return !el.closest('[class*="es-popup-content"], [class*="es-modal"], [id*="es-popup-content"], form[class*="es-"], [class*="es-form-container"]');
    });
    if (!natives.length) return;
    ES.found = true;
    natives.forEach(function (el) {
      var inCart = !!el.closest('[data-cart-drawer], [data-main-cart], .drawer, .cart-aside');
      if (inCart) ES.cart = el; else if (!ES.prod || !document.body.contains(ES.prod)) ES.prod = el;
      if (CF.esHide !== false && !el.classList.contains('es-theme-hidden')) el.classList.add('es-theme-hidden');
    });
    document.documentElement.classList.add('has-easysell');
  }
  var esScanT; function esQueue() { clearTimeout(esScanT); esScanT = setTimeout(esScan, 120); }
  if (window.MutationObserver) new MutationObserver(esQueue).observe(document.body, { childList: true, subtree: true });
  setTimeout(esScan, 600); setTimeout(esScan, 2000);
  // open EasySell from any theme button; returns true if handled
  function esOpen(kind, fallbackUrl, opts) {
    esScan();
    if (!ES.found && !CF.easysell) return false;
    var target = kind === 'cart' ? (ES.cart && document.body.contains(ES.cart) ? ES.cart : null) : (ES.prod && document.body.contains(ES.prod) ? ES.prod : null);
    if (!target && kind !== 'cart') { var ow = $('[data-es-btn]'); if (ow) { ow.click(); return true; } }
    if (!target && fallbackUrl && kind !== 'cart' && opts && opts.tier != null && opts.tier >= 0) fallbackUrl += '&offer=' + opts.tier;
    if (target) { closePanels(); target.click(); if (kind !== 'cart') esSelectOffer(esTierIndex()); return true; }
    if (fallbackUrl) { window.location.href = fallbackUrl; return true; }
    return false;
  }
  // اختار في فورم EasySell نفس العرض اللي العميل مختاره في الصفحة
  function esTierIndex() {
    var tiers = $$('[data-product-root]:not([data-quick-root]) [data-tiers] [data-tier]');
    for (var i = 0; i < tiers.length; i++) if (tiers[i].classList.contains('is-on')) return i;
    return -1;
  }
  function esSelectOffer(idx) {
    if (CF.esSync === false || idx == null || idx < 0) return;
    var map = String(CF.esMap || '').split(/[,،\s]+/).map(function (n) { return parseInt(n, 10); }).filter(function (n) { return !isNaN(n); });
    var target = map.length ? (map[idx] != null ? map[idx] - 1 : idx) : idx;
    if (target < 0) return;
    var tries = 0, tm = setInterval(function () {
      tries++;
      var groups = $$('.es-quantity-offers').filter(function (g) { return g.offsetParent !== null; });
      var g = groups[groups.length - 1];
      var cs = g ? $$('.es-qo-container', g) : [];
      if (cs.length) {
        clearInterval(tm);
        var c = cs[Math.min(target, cs.length - 1)];
        if (c.getAttribute('offer-selected') !== 'true') (c.querySelector('.offer-radio') || c).click();
      }
      if (tries > 40) clearInterval(tm);
    }, 100);
  }
  on(document, 'click', function (e) { if (e.target.closest('[data-es-btn]')) esSelectOffer(esTierIndex()); });
  T.esOpen = esOpen; T.ES = ES; T.esSelectOffer = esSelectOffer;
  on(document, 'click', function (e) {
    var l = e.target.closest('[data-es-link]'); if (!l) return;
    var q = l.closest('[data-quick-root]'); if (!q) return;
    var tl = $$('[data-tiers] [data-tier]', q), idx = -1;
    tl.forEach(function (x, i) { if (x.classList.contains('is-on')) idx = i; });
    if (idx >= 0 && l.href.indexOf('offer=') < 0) l.href += '&offer=' + idx;
  }, true);
  // cart: checkout + cart COD buttons → EasySell cart form (لو موجود)
  on(document, 'click', function (e) {
    if (CF.esCart === false) return;
    var b = e.target.closest('[data-cart-drawer] [name="checkout"], [data-main-cart] [name="checkout"], [data-cod-open="cart"]');
    if (!b) return;
    esScan();
    if (ES.cart && document.body.contains(ES.cart)) { e.preventDefault(); e.stopImmediatePropagation(); ES.cart.click(); }
  }, true);
  // EasySell: افتح الفورم أوتوماتيك لما ييجي من نافذة الإضافة السريعة أو الكروت (?es=1)
  if (/[?&]es=1/.test(location.search)) {
    var offerQ = (location.search.match(/[?&]offer=(\d+)/) || [])[1];
    if (offerQ != null) setTimeout(function () { var tl = $$('[data-product-root]:not([data-quick-root]) [data-tiers] [data-tier]'); if (tl[+offerQ]) tl[+offerQ].click(); }, 300);
    var esTries = 0, esT = setInterval(function () {
      esTries++; esScan();
      var hook = document.getElementById('es-form-hook'), btn = $('[data-es-btn]') || (ES.prod && document.body.contains(ES.prod) ? ES.prod : null);
      if (hook && hook.children.length) { clearInterval(esT); hook.scrollIntoView({ block: 'center', behavior: 'smooth' }); return; }
      if (btn && esTries > 3) { clearInterval(esT); btn.click(); if (!btn.hasAttribute('data-es-btn')) esSelectOffer(esTierIndex()); return; }
      if (esTries > 40) clearInterval(esT);
    }, 250);
  }

  /* quick add modal */
  on(document, 'click', function (e) {
    var q = e.target.closest('[data-quick-view]'); if (!q) return;
    e.preventDefault(); e.stopPropagation();
    var modal = $('[data-quick-modal]');
    var handle = q.getAttribute('data-quick-view');
    if (!modal) {
      modal = document.createElement('div');
      modal.className = 'ov-wrap'; modal.setAttribute('data-panel', 'quick'); modal.setAttribute('data-quick-modal', '');
      modal.innerHTML = '<div class="overlay" data-close></div><div class="qv-box" role="dialog" aria-modal="true"><button type="button" class="x-btn qv-x" data-close aria-label="إغلاق">✕</button><div data-quick-body></div></div>';
      document.body.appendChild(modal);
    }
    var body = $('[data-quick-body]', modal);
    body.innerHTML = '<div class="qv-loading"><span class="spinner"></span></div>';
    openPanel('quick');
    fetch(root + 'products/' + handle + '?view=quick').then(function (r) { if (!r.ok) throw 0; return r.text(); }).then(function (html) {
      if (html.indexOf('data-quick-root') < 0) throw 0;
      body.innerHTML = html;
      var r = $('[data-quick-root]', body); if (r) initProduct(r);
    }).catch(function () { window.location.href = root + 'products/' + handle; });
  });

  /* listeners for product-related sections */
  on(document, 'product:update', function (e) {
    var d = e.detail, v = d.variant;
    // sticky bar
    $$('[data-satc-price]').forEach(function (el) { el.textContent = formatMoney(d.total); });
    var sCmp = d.cmpUnit * d.qty + (d.total - d.mainTotal), sSave = Math.max(0, sCmp - d.total);
    var sPct = sCmp > 0 ? Math.round(sSave * 100 / sCmp) : 0;
    $$('[data-satc-compare]').forEach(function (el) { el.hidden = sSave <= 0; el.textContent = formatMoney(sCmp); });
    $$('[data-satc-pct]').forEach(function (el) {
      el.hidden = sPct <= 0; el.textContent = (el.getAttribute('data-tpl') || '-[pct]%').replace('[pct]', sPct);
    });
    $$('[data-satc-save]').forEach(function (el) {
      el.hidden = sSave <= 0; el.textContent = (el.getAttribute('data-tpl') || '[amount]').replace('[amount]', formatMoney(sSave));
    });
    $$('[data-satc-tier]').forEach(function (el) {
      var mode = el.getAttribute('data-mode') || 'offers', has = d.tier && d.tier.label, isOffer = has && (d.tier.pct > 0 || d.tier.qty > 1);
      var show = mode === 'always' ? has : (mode === 'offers' ? isOffer : false);
      el.hidden = !show; el.textContent = show ? d.tier.label : '';
    });
    // offer cta bar
    $$('[data-cta-tier]').forEach(function (el) { if (d.tier && d.tier.label) el.textContent = d.tier.label; });
    $$('[data-cta-price]').forEach(function (el) { el.textContent = formatMoney(d.mainTotal); });
    // offer contents
    $$('[data-offer-contents]').forEach(function (box) {
      var q = d.qty, val = d.cmpUnit * q, pay = d.mainTotal;
      var mq = $('[data-ofr-qty]', box); if (mq) mq.textContent = q;
      var mv = $('[data-ofr-variant]', box); if (mv) mv.textContent = v.title && v.title !== 'Default Title' ? '(' + v.title + ')' : '';
      var a = $('[data-ofr-val]', box); if (a) a.textContent = formatMoney(val);
      var b = $('[data-ofr-your]', box); if (b) b.textContent = formatMoney(pay);
      $$('[data-ofr-item]', box).forEach(function (it) {
        var show = q >= (+it.getAttribute('data-min') || 1); it.hidden = !show;
        if (show) { val += +it.getAttribute('data-val') || 0; pay += +it.getAttribute('data-your') || 0; }
      });
      $('[data-ofr-total-val]', box).textContent = formatMoney(val);
      $('[data-ofr-pay]', box).textContent = formatMoney(pay);
      $('[data-ofr-save]', box).textContent = formatMoney(Math.max(0, val - pay));
      var sw = box.parentNode.querySelector('[data-tier-switch]');
      if (sw && d.tiers.length) {
        sw.innerHTML = d.tiers.map(function (t) { return '<button type="button" class="chip' + (t.index === d.tier.index ? ' is-on' : '') + '" data-choose-tier="' + t.index + '" data-noscroll>' + esc(t.label) + '</button>'; }).join('');
      }
    });
    // tier table
    $$('[data-tier-table]').forEach(function (tb) {
      var cu = d.cmpUnit;
      $$('[data-tt-total]', tb).forEach(function (el) { var i = +el.getAttribute('data-tt-total'), t = d.tiers[i]; if (!t) return; el.textContent = formatMoney(Math.round(v.price * t.qty * (100 - t.pct) / 100)); });
      $$('[data-tt-compare]', tb).forEach(function (el) { var t = d.tiers[+el.getAttribute('data-tt-compare')]; if (t) el.textContent = formatMoney(cu * t.qty); });
      $$('[data-tt-unit]', tb).forEach(function (el) { var t = d.tiers[+el.getAttribute('data-tt-unit')]; if (t) el.textContent = formatMoney(Math.round(v.price * (100 - t.pct) / 100)); });
      $$('[data-tt-save]', tb).forEach(function (el) { var t = d.tiers[+el.getAttribute('data-tt-save')]; if (t) el.textContent = formatMoney(cu * t.qty - Math.round(v.price * t.qty * (100 - t.pct) / 100)); });
      $$('[data-choose-tier]', tb).forEach(function (b) { var on_ = +b.getAttribute('data-choose-tier') === d.tier.index; b.textContent = on_ ? b.getAttribute('data-chosen-text') : b.getAttribute('data-choose-text'); b.classList.toggle('btn--ok-on', on_); b.style.background = on_ ? 'var(--ok)' : ''; b.style.color = on_ ? '#fff' : ''; });
    });
  });
  on(document, 'click', function (e) {
    var ct = e.target.closest('[data-choose-tier]');
    if (ct) {
      var i = +ct.getAttribute('data-choose-tier'); var t = $$('[data-product-root] [data-tier]')[i]; if (t) t.click();
      if (!ct.hasAttribute('data-noscroll')) scrollToBuy();
      return;
    }
    if (e.target.closest('[data-scroll-buy]')) scrollToBuy();
  });
  function scrollToBuy() {
    var el = $('#buybox') || $('[data-tiers]') || $('[data-atc]'); if (!el) return;
    window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 90, behavior: 'smooth' });
  }
  $$('a[href="#buybox"]').forEach(function (a) { on(a, 'click', function (e) { e.preventDefault(); scrollToBuy(); }); });

  /* viewers count */
  $$('[data-viewers]').forEach(function (el) {
    var mn = +el.getAttribute('data-min') || 10, mx = +el.getAttribute('data-max') || mn + 8, tpl = el.getAttribute('data-template');
    var set = function () { el.textContent = tpl.replace('[n]', mn + Math.floor(Math.random() * (mx - mn + 1))); };
    set(); setInterval(set, 7000);
  });
  /* rotating mini reviews */
  $$('[data-mini-reviews]').forEach(function (box) {
    var items = $$('[data-mini-review]', box); if (items.length < 2) return; var i = 0;
    setInterval(function () { items[i].style.display = 'none'; i = (i + 1) % items.length; items[i].style.display = ''; }, (+box.getAttribute('data-interval') || 6) * 1000);
  });
  /* tabs */
  $$('[data-tabs]').forEach(function (tb) {
    $$('[data-tab]', tb).forEach(function (b) {
      on(b, 'click', function () {
        var k = b.getAttribute('data-tab');
        $$('[data-tab]', tb).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $$('[data-tab-panel]', tb).forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== k; });
      });
    });
  });
  /* reels */
  $$('[data-reel]').forEach(function (r) {
    on(r, 'click', function () {
      var v = $('video', r); if (!v) return;
      if (v.paused) { $$('[data-reel] video').forEach(function (o) { if (o !== v) { o.pause(); o.closest('.reel').classList.remove('is-playing'); } }); v.controls = true; v.play(); r.classList.add('is-playing'); }
    });
  });
  /* video faq */
  $$('[data-vfaq]').forEach(function (box) {
    $$('[data-vfaq-q]', box).forEach(function (b) {
      on(b, 'click', function () {
        var k = b.getAttribute('data-vfaq-q');
        $$('[data-vfaq-q]', box).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $$('[data-vfaq-panel]', box).forEach(function (p) { var hit = p.getAttribute('data-vfaq-panel') === k; p.hidden = !hit; var v = $('video', p); if (v && !hit) v.pause(); });
      });
    });
  });
  /* review filters */
  $$('[data-rev-filters]').forEach(function (f) {
    var list = f.parentNode.querySelector('[data-rev-list]');
    $$('[data-rev-filter]', f).forEach(function (b) {
      on(b, 'click', function () {
        var k = b.getAttribute('data-rev-filter');
        $$('[data-rev-filter]', f).forEach(function (x) { x.classList.toggle('is-on', x === b); });
        $$('[data-stars]', list).forEach(function (r) {
          var s = r.getAttribute('data-stars'), ph = r.getAttribute('data-photo') === '1';
          r.hidden = !(k === 'all' || (k === 'photo' ? ph : s === k));
        });
      });
    });
  });

  /* =========================================================
     PICK-GRIDS: home bundle builder + FBT
     ========================================================= */
  function togglePick(el) { el.classList.toggle('is-on'); el.setAttribute('aria-checked', el.classList.contains('is-on')); }
  $$('[data-bundle]').forEach(function (b) {
    var items = $$('[data-bundle-item]', b);
    var cfg = { min: +b.dataset.min || 2, t1: +b.dataset.t1, p1: +b.dataset.p1, t2: +b.dataset.t2, p2: +b.dataset.p2 };
    function upd() {
      var sel = items.filter(function (i) { return i.classList.contains('is-on'); });
      var n = sel.length, sum = sel.reduce(function (a, i) { return a + (+i.dataset.price || 0); }, 0);
      var pct = n >= cfg.t2 ? cfg.p2 : n >= cfg.t1 ? cfg.p1 : 0;
      var tot = Math.round(sum * (100 - pct) / 100);
      $('[data-bundle-msg]', b).textContent = n === 0 ? b.dataset.msg0 : n < cfg.t1 ? b.dataset.msg1 : n < cfg.t2 ? b.dataset.msg2 : b.dataset.msg3;
      $('[data-bundle-total]', b).textContent = formatMoney(tot);
      $('[data-bundle-orig]', b).textContent = pct ? formatMoney(sum) : '';
      $('[data-bundle-save]', b).textContent = pct ? b.dataset.save.replace('[amount]', formatMoney(sum - tot)) : '';
      $('[data-bundle-add]', b).classList.toggle('is-disabled', n < cfg.min);
    }
    items.forEach(function (i) {
      on(i, 'click', function () { togglePick(i); upd(); });
      on(i, 'keydown', function (e) { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); togglePick(i); upd(); } });
    });
    on($('[data-bundle-add]', b), 'click', function () {
      var sel = items.filter(function (i) { return i.classList.contains('is-on'); });
      if (sel.length < cfg.min) { toast(b.dataset.msg0); return; }
      var tag = b.dataset.label + ' #' + Date.now().toString().slice(-5);
      addItems(sel.map(function (i) { return { id: +i.dataset.variant, quantity: 1, properties: { _bundle: tag } }; })).then(function () { sel.forEach(togglePick); upd(); });
    });
    upd();
  });
  $$('[data-fbt]').forEach(function (b) {
    var items = $$('[data-fbt-item]', b), pct = +b.dataset.pct || 0, min = +b.dataset.min || 2;
    function upd() {
      var sel = items.filter(function (i) { return i.classList.contains('is-on'); });
      var sum = sel.reduce(function (a, i) { return a + (+i.dataset.price || 0); }, 0);
      var p = sel.length >= min ? pct : 0, tot = Math.round(sum * (100 - p) / 100);
      $('[data-fbt-count]', b).textContent = sel.length;
      $('[data-fbt-total]', b).textContent = formatMoney(tot);
      $('[data-fbt-orig]', b).textContent = p ? formatMoney(sum) : '';
      $('[data-fbt-save]', b).textContent = p ? b.dataset.save.replace('[amount]', formatMoney(sum - tot)) : b.dataset.hint;
      items.forEach(function (i) { i.classList.toggle('pick--fade', !i.classList.contains('is-on')); });
    }
    items.forEach(function (i) { on(i, 'click', function () { togglePick(i); upd(); }); });
    on($('[data-fbt-add]', b), 'click', function () {
      var sel = items.filter(function (i) { return i.classList.contains('is-on'); }); if (!sel.length) return;
      addItems(sel.map(function (i) { return { id: +i.dataset.variant, quantity: 1, properties: sel.length >= min ? { _bundle: 'FBT' } : {} }; }));
    });
    upd();
  });

  /* =========================================================
     BUNDLE PAGE WIZARD (اعمل باكدجك)
     ========================================================= */
  $$('[data-bundle-wizard]').forEach(function (w) {
    var step = 1, items = $$('[data-bw-item]', w), wraps = $$('[data-bw-wrap]', w);
    var cfg = { min: +w.dataset.min || 2, t1: +w.dataset.t1, p1: +w.dataset.p1, t2: +w.dataset.t2, p2: +w.dataset.p2 };
    var to = $('[data-bw-to]', w), msg = $('[data-bw-msg]', w), fr = $('[data-bw-from]', w);
    function sel() { return items.filter(function (i) { return i.classList.contains('is-on'); }); }
    function wrapSel() { return wraps.filter(function (x) { return x.classList.contains('is-on'); })[0]; }
    function render() {
      $$('[data-bw-panel]', w).forEach(function (p) { p.classList.toggle('is-on', +p.dataset.bwPanel === step); });
      $$('[data-bw-step]', w).forEach(function (s) { var n = +s.dataset.bwStep; s.classList.toggle('is-on', n === step); s.classList.toggle('is-done', n < step); $('.bstep__n', s).textContent = n < step ? '✓' : n; });
      var back = $('[data-bw-back]', w); back.style.opacity = step > 1 ? 1 : .4;
      $('[data-bw-next]', w).textContent = step < 3 ? w.dataset.next : w.dataset.finish;
      var s = sel(), sum = s.reduce(function (a, i) { return a + (+i.dataset.price || 0); }, 0);
      var pct = s.length >= cfg.t2 ? cfg.p2 : s.length >= cfg.t1 ? cfg.p1 : 0, disc = Math.round(sum * pct / 100);
      var wr = wrapSel(), wp = wr ? +wr.dataset.price || 0 : 0;
      $('[data-bw-lines]', w).innerHTML = s.length ? s.map(function (i) { return '<div class="sumrow small"><span style="color:var(--c-ink)">' + esc(i.dataset.title) + '</span><span>' + formatMoney(+i.dataset.price) + '</span></div>'; }).join('') : '<span class="muted">' + esc(w.dataset.none) + '</span>';
      $('[data-bw-wrapname]', w).textContent = wr ? wr.dataset.title : '—';
      $('[data-bw-wrapprice]', w).textContent = wp ? formatMoney(wp) : S.free;
      var dr = $('[data-bw-disc]', w); dr.hidden = !pct; $('[data-bw-pct]', w).textContent = pct + '%'; $('[data-bw-discval]', w).textContent = '−' + formatMoney(disc);
      $('[data-bw-total]', w).textContent = formatMoney(sum - disc + wp);
      $('[data-bw-add]', w).classList.toggle('is-disabled', s.length < cfg.min);
      var pv = function (k, el, d) { var t = $('[data-bw-prev-' + k + ']', w); if (t) t.textContent = (el && el.value) || d; };
      pv('to', to, w.dataset.toPh); pv('msg', msg, w.dataset.msgPh); pv('from', fr, w.dataset.fromPh);
    }
    items.forEach(function (i) { on(i, 'click', function () { togglePick(i); render(); }); });
    wraps.forEach(function (x) { on(x, 'click', function () { wraps.forEach(function (y) { y.classList.toggle('is-on', y === x); }); render(); }); });
    [to, msg, fr].forEach(function (el) { if (el) on(el, 'input', render); });
    function go(n) { if (n > 1 && sel().length < cfg.min) { toast(w.dataset.minMsg); return; } step = Math.max(1, Math.min(3, n)); render(); }
    $$('[data-bw-step]', w).forEach(function (s) { on(s, 'click', function () { go(+s.dataset.bwStep); }); });
    on($('[data-bw-back]', w), 'click', function () { go(step - 1); });
    function add() {
      var s = sel(); if (s.length < cfg.min) { toast(w.dataset.minMsg); step = 1; render(); return; }
      var tag = (w.dataset.label || 'باكدج') + ' #' + Date.now().toString().slice(-5);
      var its = s.map(function (i) { return { id: +i.dataset.variant, quantity: 1, properties: { _bundle: tag } }; });
      var wr = wrapSel();
      var card = {}; if (to && to.value) card['إلى'] = to.value; if (msg && msg.value) card['الرسالة'] = msg.value; if (fr && fr.value) card['من'] = fr.value; card._bundle = tag;
      if (wr && +wr.dataset.variant) its.push({ id: +wr.dataset.variant, quantity: 1, properties: card });
      else if (s.length) its[0].properties = Object.assign(its[0].properties, card);
      addItems(its).then(function () { s.forEach(togglePick); step = 1; if (to) to.value = ''; if (msg) msg.value = ''; if (fr) fr.value = ''; render(); });
    }
    on($('[data-bw-next]', w), 'click', function () { if (step < 3) go(step + 1); else add(); });
    on($('[data-bw-add]', w), 'click', add);
    if (wraps[0]) wraps[0].classList.add('is-on');
    render();
  });

  /* =========================================================
     LANDING PAGE TIERS
     ========================================================= */
  $$('[data-landing]').forEach(function (l) {
    var tiers = $$('[data-land-tier]', l), cur = 0;
    function set(i) {
      cur = i; tiers.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
      $$('[data-land-sel]').forEach(function (el) { el.textContent = tiers[i].dataset.label + ' — ' + tiers[i].dataset.totalF; });
    }
    tiers.forEach(function (t, k) { on(t, 'click', function () { set(k); }); });
    var def = tiers.filter(function (t) { return t.hasAttribute('data-default'); })[0];
    if (tiers.length) set(def ? tiers.indexOf(def) : 0);
    on(document, 'click', function (e) {
      var b = e.target.closest('[data-land-buy]'); if (!b || !tiers.length) return;
      var t = tiers[cur]; b.classList.add('is-loading');
      var mode = l.dataset.mode;
      if (mode === 'checkout') {
        var p = l.dataset.discount ? '?discount=' + encodeURIComponent(l.dataset.discount) : '';
        window.location.href = root + 'cart/' + t.dataset.variant + ':' + t.dataset.qty + p; return;
      }
      addItems([{ id: +t.dataset.variant, quantity: +t.dataset.qty, properties: { _offer: t.dataset.label } }], { open: mode !== 'cart-go' })
        .then(function () { if (mode === 'cart-go') window.location.href = root + 'checkout'; });
    });
  });

  /* =========================================================
     MISC PAGES: tracking, quiz, corporate calc, gift card builder
     ========================================================= */
  $$('[data-track-form]').forEach(function (f) {
    on(f, 'submit', function (e) {
      var url = f.dataset.url; if (!url) return;
      e.preventDefault(); var fd = new FormData(f);
      window.location.href = url.replace('[order]', encodeURIComponent(fd.get('order') || '')).replace('[phone]', encodeURIComponent(fd.get('phone') || ''));
    });
  });
  $$('[data-quiz]').forEach(function (q) {
    var qs = $$('[data-quiz-q]', q), i = 0, score = 0, bar = $('[data-quiz-bar] span', q), res = $('[data-quiz-result]', q);
    function show() {
      qs.forEach(function (x, k) { x.hidden = k !== i; });
      if (bar) bar.style.setProperty('--w', (i / qs.length * 100) + '%');
      $$('[data-quiz-n]', q).forEach(function (n) { n.textContent = Math.min(i + 1, qs.length); });
      if (i >= qs.length) {
        $('[data-quiz-run]', q).hidden = true; res.hidden = false;
        var pct = Math.round(score / (qs.length * 2) * 100);
        $$('[data-quiz-band]', res).forEach(function (b) { b.hidden = !(pct >= +b.dataset.min && pct <= +b.dataset.max); });
        $('[data-quiz-score]', res).textContent = pct + '%';
      }
    }
    $$('[data-quiz-opt]', q).forEach(function (o) { on(o, 'click', function () { score += +o.dataset.quizOpt || 0; i++; show(); }); });
    on($('[data-quiz-reset]', q), 'click', function () { i = 0; score = 0; res.hidden = true; $('[data-quiz-run]', q).hidden = false; show(); });
    show();
  });
  $$('[data-corp-calc]').forEach(function (c) {
    var boxes = $$('[data-corp-box]', c), range = $('[data-corp-qty]', c), adds = $$('[data-corp-add]', c);
    var tiers = JSON.parse(c.dataset.tiers || '[]');
    function upd() {
      var b = boxes.filter(function (x) { return x.classList.contains('is-on'); })[0] || boxes[0]; if (!b) return;
      var q = +range.value, base = +b.dataset.price || 0;
      adds.forEach(function (a) { if (a.classList.contains('is-on')) base += +a.dataset.price || 0; });
      var pct = 0; tiers.forEach(function (t) { if (q >= t.min) pct = t.pct; });
      var unit = Math.round(base * (100 - pct) / 100);
      $('[data-corp-qty-out]', c).textContent = q;
      $('[data-corp-unit]', c).textContent = formatMoney(unit);
      $('[data-corp-total]', c).textContent = formatMoney(unit * q);
      $('[data-corp-save]', c).textContent = formatMoney((base - unit) * q);
      $('[data-corp-pct]', c).textContent = pct + '%';
      $$('[data-corp-tier]', c).forEach(function (t) { t.classList.toggle('is-on', q >= +t.dataset.min && (+t.dataset.max ? q <= +t.dataset.max : true)); });
      var hid = $('[data-corp-summary]', c.closest('.sec') || document); if (hid) hid.value = b.dataset.title + ' × ' + q + ' — ' + formatMoney(unit * q);
    }
    boxes.forEach(function (b) { on(b, 'click', function () { boxes.forEach(function (x) { x.classList.toggle('is-on', x === b); }); upd(); }); });
    adds.forEach(function (a) { on(a, 'click', function () { a.classList.toggle('is-on'); upd(); }); });
    on(range, 'input', upd); if (boxes[0]) boxes[0].classList.add('is-on'); upd();
  });
  $$('[data-gc-builder]').forEach(function (g) {
    var amts = $$('[data-gc-amount]', g);
    var setAmt = function (a) {
      amts.forEach(function (x) { x.classList.toggle('is-on', x === a); });
      $$('[data-gc-show]').forEach(function (el) { el.textContent = a.dataset.label; });
      var vi = $('[data-gc-variant]', g); if (vi) vi.value = a.dataset.variant;
      var bonus = $('[data-gc-bonus]', g); if (bonus) { bonus.hidden = !a.dataset.bonus; bonus.textContent = '🎁 ' + (a.dataset.bonus || ''); }
    };
    amts.forEach(function (a) { on(a, 'click', function () { setAmt(a); }); });
    if (amts[0]) setAmt(amts.filter(function (a) { return a.hasAttribute('data-default'); })[0] || amts[0]);
    $$('[data-gc-input]', g).forEach(function (i) {
      on(i, 'input', function () { $$('[data-gc-preview="' + i.dataset.gcInput + '"]').forEach(function (p) { p.textContent = i.value || p.dataset.ph; }); });
    });
  });
  $$('[data-chip-group]').forEach(function (grp) {
    $$('.chip', grp).forEach(function (c) { on(c, 'click', function () { $$('.chip', grp).forEach(function (x) { x.classList.toggle('is-on', x === c); }); var inp = $('input[type=hidden]', grp); if (inp) inp.value = c.dataset.value || c.textContent; }); });
  });

  /* bottom nav presence */
  if ($('[data-bnav]')) document.body.classList.add('has-bnav');

  /* Theme editor support */
  on(document, 'shopify:section:load', function () { $$('.reveal').forEach(function (el) { el.classList.add('is-in'); }); tickCountdowns(); refreshLists(); bindCartUI(); });
})();
